import React from 'react';
import { LookupsContext, ILookupsContext } from './LookupsContext';
import { useAsyncData } from '@shared/react';
import { useErrorNotify } from '@features/useErrorNotify';
import { getLookups } from './api';

export const LookupsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const {
        data: lookups,
        loading: lookupsLoading,
        error: lookupsError,
    } = useAsyncData(
        async () => {
            return await getLookups();
        },
        null,
        [],
    );

    useErrorNotify(lookupsError, 'Daily Settlement');

    const value: ILookupsContext = {
        lookups,
        lookupsLoading,
    };

    return <LookupsContext.Provider value={value}>{children}</LookupsContext.Provider>;
};
